import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "forward-link__link" }

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { InlineLink } from "@/components/modules";
import { withDefaults, defineOptions } from "vue";

interface Props {
  modifires?: typeModifires;
  align?: "left" | "center" | "right";
  href?: string;
  to?: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'forward-link',
  props: {
    modifires: { type: [String, Array, Boolean] },
    align: {},
    href: {},
    to: {},
    target: {}
  },
  setup(__props: any) {

const props = __props;





const componentClass = () =>
  mapModifires(
    "forward-link",
    mergeModifires(props.modifires, props.align && `align-${props.align}`)
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(InlineLink), {
        onClick: _ctx.$attrs.onClick,
        to: _ctx.to,
        href: _ctx.href,
        target: _ctx.target
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["onClick", "to", "href", "target"])
    ])
  ], 2))
}
}

})